// extracted by mini-css-extract-plugin
module.exports = {"plus":"MyResumes_plus__2YVl5","dog":"MyResumes_dog__11biP"};